module.exports = __webpack_public_path__ + "static/media/tad-portal-logo.153a87c9.png";